module.exports = __webpack_public_path__ + "static/media/waiting_list.98fcbc4e.svg";